const theme = {
  colors: {
    Brand1PenBlue: "#00615E",
    Brand11steplighter: "#0b2c7f",
    Brand12steplighter: "#E0F3F1",
    Brand1PenBlue88: "rgba(0, 97, 94, 0.88)",
    Brand2Olivine: "#9eb25d",
    Brand21steplighter: "#abbf6d",
    Brand21steplighter2: "#b9cb7f",
    Brand3NaplesYellow: "#f1db4b",
    Brand31steplighter: "#fde966",
    Brand32steplighter: "#ffef85",
    Error: "#cc0202",
    Brand4LavenderWeb: "#e9ebf8",
    Brand5FrenchGrey: "#b4b8c5",
    GhostWhite: "#f4f4f9",
    White: "#ffffff",
    Grey10: "#efefef",
    Grey25: "#c0c0c0",
    Grey300: "#E0E0E0",
    Grey600: "#6C757D",
    PlaceholderGrey: "#a9a9a9",
    Grey50: "#7d7d7d",
    Black: "#000000",
    Transparent: "#ffffff",
    MobileMenuBG: "rgba(0, 0, 0, 0.8)",
    Blue400: "#ECF4FE",
    Grey500: "#AEB8C1",
    Grey400: "#C2C2C2",
    error: "#F20800",
    Success: "#00AD3F",
    Red400: "#FEF2F2",
    Green400: "#EAF5E6",
    Warning: "#FBAB18",
    Yellow400: "#FCF3E6",
  },
};

export default theme;
